export const getChartPreview = async (coinName, duration, interval, currency) => {
    try {
        // eslint-disable-next-line max-len
        let response = await fetch(`/api/coin-data/chart-preview?interval=${duration === '1d' ? '1h' : duration}&name=${coinName}${interval ?
            '&start=' + interval.start + '&end=' + interval.end : ''}&quote=${currency}`);
        return await response.json()
    } catch (error) {
        console.error(error);
    }
}